// extracted by mini-css-extract-plugin
export var how = "how-module--how--4fa6a";
export var steps = "how-module--steps--514cc";
export var wrapper = "how-module--wrapper--7a467";